var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.item[_vm.header.value]
        ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
            _vm._v("mdi-check-bold"),
          ])
        : _c("v-icon", { attrs: { small: "", color: "error" } }, [
            _vm._v("mdi-close-thick"),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }